// Townhouse HRV evidence (owner request 2026-09-26): a townhouse inspection
// being completed now needs the HRV set to Off or Reduced plus at least one
// photo of it. Inspections completed before that keep what they have and stay
// editable. The server applies the same rule (suite-inspection-hrv.ts).

export const HRV_COMPLETION_SETTINGS = ['off', 'reduce'];

// A save is a new completion when it submits a new record or promotes a draft.
export const isNewCompletion = ({ isDraft, isCreating, wasDraft }) =>
  !isDraft && (isCreating === true || wasDraft === true);

/** Returns { field, message } when the HRV evidence is missing, otherwise null. */
export const hrvEvidenceProblem = ({ isTownhouse, hrvSetting, photoCount }) => {
  if (!isTownhouse) return null;
  if (!HRV_COMPLETION_SETTINGS.includes(String(hrvSetting || '').trim().toLowerCase())) {
    return { field: 'hrv_setting', message: 'Select the HRV setting (Off or Reduced).' };
  }
  if (!(photoCount > 0)) {
    return { field: 'hrv_photos', message: 'Add a photo of the HRV setting. Save as a draft if you do not have one yet.' };
  }
  return null;
};
